// const BASE_URL = "http://localhost:3001";
const BASE_URL = "https://api.dropn.trangotechdevs.com";
// const BASE_URL = "https://api.bizooka.co";
// APIs design from Shaheer
const API_URL = BASE_URL + "/api/v1/admin";

const INITIAL_TOKEN = "f47ac10b-58cc-4372-a567-0e02b2c3d479";

export { API_URL, BASE_URL, INITIAL_TOKEN };
